import React from 'react'
import { Popover } from 'antd'

import CoreRenderFunction from 'DisplayCore'

const TechBasePopover = props => {
  let {
    content = '',
    title = '',
    children
  } = props.item

  return(
    <Popover content={ content } title={ title }>
      {
        children?.map( child => <CoreRenderFunction {...props} item={ child } />)
      }
    </Popover>
  )
}

export default TechBasePopover